
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.116 4.116A1.25 1.25 0 0113 4.25h-2c.035-.047.074-.092.116-.134zM7.792 7.861a6.25 6.25 0 012.381-2.111h3.654a6.25 6.25 0 013.423 5.268V14c0 .03.002.06.005.09a4.749 4.749 0 00.83 2.16H5.915l.065-.096a4.75 4.75 0 00.764-2.064.75.75 0 00.005-.09v-2.982a6.25 6.25 0 011.042-3.157zm.458 9.889H4a.75.75 0 01-.37-1.403 3.25 3.25 0 001.62-2.395V11v-.035a7.75 7.75 0 014.042-6.447 2.75 2.75 0 015.415 0A7.75 7.75 0 0118.75 11v2.952a3.25 3.25 0 001.62 2.395.75.75 0 01-.37 1.403h-4.25V18a3.75 3.75 0 01-7.5 0v-.25zm6 0V18a2.25 2.25 0 11-4.5 0v-.25h4.5z"}})])
          )
        }
      }
    